import { FunctionComponent } from "react";
import { faCoins, faFlaskVial } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

interface FieldMappingFooterProps {
	mappedCount: number;
	aiCount: number;
	summaryLabel: string;
	creditPillLabel: string;
	testIdPrefix: string;
	previewLabel?: string;
	onPreview?: () => void;
}

export const FieldMappingFooter: FunctionComponent<FieldMappingFooterProps> = ({
	mappedCount,
	aiCount,
	summaryLabel,
	creditPillLabel,
	testIdPrefix,
	previewLabel,
	onPreview,
}) => {
	return (
		<div
			className="mt-4 pt-3 border-t border-border-light flex items-center gap-3 text-xs text-text-meta"
			data-testid={`${testIdPrefix}-footer`}
		>
			<span data-testid={`${testIdPrefix}-footer-summary`}>{summaryLabel}</span>
			{aiCount > 0 && (
				<span
					className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md border border-border-light bg-brand-white text-text-meta"
					data-testid={`${testIdPrefix}-footer-credit-pill`}
				>
					<Icon className="w-3 h-3" icon={faCoins} />
					<span className="text-text font-semibold">{creditPillLabel}</span>
				</span>
			)}
			{onPreview && previewLabel && mappedCount > 0 && (
				<div className="ml-auto" data-testid={`${testIdPrefix}-footer-preview`}>
					<Button
						color={ButtonColor.ACTION_SECONDARY}
						image={<Icon className="w-[14px] h-[14px] text-gray-700 mr-2" icon={faFlaskVial} />}
						size={ButtonSize.S}
						title={previewLabel}
						onClick={onPreview}
					/>
				</div>
			)}
		</div>
	);
};
